import { render, staticRenderFns } from "./newShare.vue?vue&type=template&id=2cfb8b24&scoped=true&"
import script from "./newShare.vue?vue&type=script&lang=js&"
export * from "./newShare.vue?vue&type=script&lang=js&"
import style0 from "./newShare.vue?vue&type=style&index=0&id=2cfb8b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfb8b24",
  null
  
)

export default component.exports